/* Hanezza / opt-in Bento collection color/model ordering.
   Preserve variant URLs, prices, card identity and rollback to Shopify on unsafe scans. */

!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="993d4d9b-0167-5bd5-adc5-1997b20b2768")}catch(e){}}();
(function (root) {
  'use strict';

  function shouldDisperse(sortBy) {
    return sortBy === null || sortBy === '' || sortBy === 'manual';
  }

  function disperseCards(cards, getModelId, previousModelId) {
    if (!Array.isArray(cards) || cards.length < 2) return cards;
    var groups = new Map();
    cards.forEach(function (card) {
      var id = String(getModelId(card));
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(card);
    });
    if (groups.size < 2) return cards;

    var output = [];
    var placed = new Map();
    groups.forEach(function (group, id) { placed.set(id, 0); });
    var previous = previousModelId == null ? null : String(previousModelId);

    // Choose the next model with the fewest unavoidable adjacent repeats.
    // Among equally safe choices, prioritize models not yet shown.
    while (output.length < cards.length) {
      var pickId = null;
      var pickScore = Infinity;
      var pickBoundary = Infinity;
      var pickPlaced = Infinity;
      var remainingAfterPick = cards.length - output.length - 1;
      groups.forEach(function (group, id) {
        if (!group.length) return;
        var forced = 0;
        groups.forEach(function (other, otherId) {
          var n = other.length - (otherId === id ? 1 : 0);
          var penalty = 2 * n - remainingAfterPick - (otherId === id ? 0 : 1);
          if (penalty > forced) forced = penalty;
        });
        var boundary = previous === id ? 1 : 0;
        var score = boundary + forced;
        var shown = placed.get(id);
        if (score < pickScore ||
            (score === pickScore && boundary < pickBoundary) ||
            (score === pickScore && boundary === pickBoundary && shown < pickPlaced)) {
          pickId = id;
          pickScore = score;
          pickBoundary = boundary;
          pickPlaced = shown;
        }
      });
      if (pickId == null) break;
      output.push(groups.get(pickId).shift());
      placed.set(pickId, placed.get(pickId) + 1);
      previous = pickId;
    }
    return output;
  }


  // True color-specific price ordering (integer Shopify minor currency units).
  // Only equal-price tiers may be diversified; numeric ordering always wins.
  function sortVariantCardsByPrice(cards, sortBy) {
    if (!Array.isArray(cards)) throw new TypeError('price sort requires an array');
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') {
      throw new TypeError('Unsupported price sort mode');
    }
    var direction = sortBy === 'price-ascending' ? 1 : -1;
    var ordered = cards.map(function (card, index) {
      var raw = card && card.dataset && card.dataset.bentoPriceCents;
      if (typeof raw !== 'string' || !/^\d+$/.test(raw)) {
        throw new TypeError('Invalid price cents for blouse color card');
      }
      var price = Number(raw);
      if (!Number.isSafeInteger(price) || price < 0) {
        throw new TypeError('Invalid price cents outside safe range');
      }
      var model = card.dataset.productId;
      if (typeof model !== 'string' || !model) {
        throw new TypeError('Invalid price card model identifier');
      }
      return { card: card, price: price, index: index };
    });
    ordered.sort(function (a,b) {
      return direction * (a.price - b.price) || a.index - b.index;
    });
    var output = [];
    for (var i=0; i<ordered.length;) {
      var end=i+1;
      while (end<ordered.length && ordered[end].price === ordered[i].price) end++;
      var tier=ordered.slice(i,end).map(function(x){ return x.card; });
      var lastModel=output.length ? output[output.length-1].dataset.productId : null;
      tier=disperseCards(tier, function(c){return c.dataset.productId;}, lastModel);
      Array.prototype.push.apply(output,tier);
      i=end;
    }
    return output;
  }


  function buildPricePageUrls(href, totalPages) {
    if (!Number.isInteger(totalPages) || totalPages < 1 || totalPages > 8) {
      throw new TypeError('Collection page limit exceeded or invalid');
    }
    var current=new URL(href);
    var mode=current.searchParams.get('sort_by');
    if (mode !== 'price-ascending' && mode !== 'price-descending') {
      throw new TypeError('URL is not a price sort');
    }
    var page=Number(current.searchParams.get('page') || 1);
    if (!Number.isInteger(page) || page < 1 || page > totalPages) {
      throw new TypeError('Invalid current collection page');
    }
    var urls=[];
    for (var index=1; index<=totalPages; index++) {
      if (index === page) continue;
      var url=new URL(current.href);
      url.searchParams.set('page',String(index));
      urls.push({page:index,url:url.href});
    }
    return urls;
  }


  function flattenCompletePricePages(pages, maxCards) {
    if (!Array.isArray(pages) || !pages.length || !Number.isInteger(maxCards) || maxCards < 1) {
      throw new TypeError('Invalid collection page limit');
    }
    var result = [];
    for (var page=0;page<pages.length;page++) {
      if (!Array.isArray(pages[page])) throw new Error('Incomplete collection price pages');
      // A Shopify page can legitimately have zero cards when its products are
      // fully sold out and show_unavailable_variants is false.
      for (var i=0; i<pages[page].length; i++) {
        if (result.length >= maxCards) throw new Error('Collection price card safety limit exceeded');
        result.push(pages[page][i]);
      }
    }
    if (!result.length) throw new Error('Empty collection price card set');
    return result;
  }

  // Keep the original merchandising card after the first ten products.
  // The same pure rule is used by default model order and complete price order.
  function insertPromoAfterTen(cards, promos) {
    var items = Array.isArray(cards) ? cards : [];
    var extras = Array.isArray(promos) ? promos : [];
    var result = [];
    items.forEach(function (card, index) {
      if (index === 10) Array.prototype.push.apply(result, extras);
      result.push(card);
    });
    if (items.length < 10) Array.prototype.push.apply(result, extras);
    return result;
  }

  // A complete cross-page scan is affordable for small collections only.
  // Keep model dispersion independent from this price-sort limit.
  function priceScanMode(totalPages, visibleCardCount) {
    if (!Number.isInteger(totalPages) || totalPages < 1 ||
        !Number.isInteger(visibleCardCount) || visibleCardCount < 0) {
      return 'unavailable';
    }
    if (totalPages > 8) return 'shopify-large';
    if (totalPages === 1 && visibleCardCount === 0) return 'empty';
    return 'full';
  }

  // Explicit price sorts need all source product pages: Shopify sorts parent
  // products, whereas Hanezza displays a different price for each color card.
  // This read-only, same-origin scan is bounded, atomic and fail-closed.
  async function loadAllVariantPrices(grid, sortBy, rootEl) {
    function isBentoCard(el) {
      return el && el.nodeType === 1 && el.matches('.bento-card-normal[data-product-id][data-bento-price-cents]');
    }
    var pageCount = Number(grid.dataset.bentoTotalPages);
    var currentCards = Array.prototype.filter.call(grid.children, isBentoCard);
    var scanMode = priceScanMode(pageCount, currentCards.length);
    var english = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    if (scanMode === 'shopify-large') {
      // No fetch storm for 23+ pages. Product-level price order is not a
      // globally correct variant-price sort: tell visitors the difference.
      var info = document.createElement('p');
      info.className = 'bento-price-sort-status';
      info.setAttribute('role', 'status');
      info.setAttribute('aria-live', 'polite');
      info.textContent = english
        ? "This large collection uses Shopify's product price order; individual color options are not re-sorted."
        : "Bu büyük koleksiyonda Shopify ürün fiyat sırası kullanılır; tüm renkler tek tek sıralanmaz.";
      grid.parentNode.insertBefore(info, grid);
      return;
    }
    if (scanMode === 'empty') return;
    if (scanMode === 'unavailable') {
      console.warn('Hanezza Bento: missing pagination data for price sort');
      return;
    }

    var status = document.createElement('p');
    status.className = 'bento-price-sort-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = english ? 'Sorting all colors by price...' : 'Tüm renkler fiyata göre sıralanıyor...';
    grid.parentNode.insertBefore(status, grid);
    var loadMoreBtn = document.getElementById('bento-load-more-btn');
    var hadLoadMore = Boolean(loadMoreBtn);
    var oldDisabled = hadLoadMore ? loadMoreBtn.disabled : false;
    if (hadLoadMore) loadMoreBtn.disabled = true;
    grid.setAttribute('aria-busy', 'true');
    grid.classList.add('bento-price-sort-loading');
    var abortController = new AbortController();
    var timer = setTimeout(function () { abortController.abort(); }, 9000);
    var success = false;
    try {
      var currentPage = Number(grid.dataset.bentoCurrentPage);
      var targets = buildPricePageUrls(window.location.href, pageCount);
      if (!Number.isInteger(currentPage) || currentPage < 1 || currentPage > pageCount) {
        throw new Error('Invalid collection page scope');
      }
      var allPages = new Array(pageCount);
      // Shopify can render a valid last page with zero available color cards.
      allPages[currentPage-1] = currentCards;
      await Promise.all(targets.map(async function (target) {
        var url = new URL(target.url);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
          throw new Error('Unsafe collection page URL');
        }
        var response = await fetch(url.href, {
          credentials: 'same-origin',
          signal: abortController.signal
        });
        if (!response.ok) throw new Error('Collection price page HTTP ' + response.status);
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceRoot = doc.querySelector('.bento-collection[data-bento-color-spread="true"]');
        var source = sourceRoot && sourceRoot.querySelector('.bento-grid');
        if (!source || sourceRoot.dataset.bentoCollectionId !== rootEl.dataset.bentoCollectionId ||
            Number(source.dataset.bentoTotalPages) !== pageCount ||
            Number(source.dataset.bentoCurrentPage) !== target.page) {
          throw new Error('Collection price page does not match the requested source page');
        }
        // An existing Shopify page with no in-stock color cards is still complete.
        var cards = Array.prototype.filter.call(source.children, isBentoCard);
        allPages[target.page-1] = cards;
      }));
      var cards = flattenCompletePricePages(allPages, 500);
      var seenIds = new Set();
      cards.forEach(function (card) {
        var cardId = card.id;
        if (!cardId || seenIds.has(cardId)) throw new Error('Duplicate or missing color card ID');
        seenIds.add(cardId);
      });
      var sorted = sortVariantCardsByPrice(cards, sortBy);
      if (sorted.length !== cards.length) throw new Error('Color price card count changed');
      // Keep exactly the current page's promotional card; ignore promotions
      // repeated by the independent Shopify pages fetched in the background.
      var promo = Array.prototype.filter.call(grid.children, function(node) {
        return node.classList && node.classList.contains('bento-promo-card');
      });
      var fragment = document.createDocumentFragment();
      insertPromoAfterTen(sorted, promo).forEach(function (node) {
        fragment.appendChild(node.ownerDocument === document ? node : document.importNode(node, true));
      });
      grid.replaceChildren(fragment);
      if (hadLoadMore) loadMoreBtn.parentElement.style.display = 'none';
      var nextPageLink = rootEl.querySelector('.bluz-next-page-link');
      if (nextPageLink) nextPageLink.hidden = true;
      status.textContent = english
        ? sorted.length + ' color options sorted by price.'
        : sorted.length + ' renk seçeneği fiyatına göre sıralandı.';
      success = true;
    } catch (error) {
      // Restore Shopify's original product order, with no partial DOM writes.
      status.textContent = english
        ? 'Color-price sorting unavailable. Original product order is shown.'
        : 'Renk fiyatları sıralanamadı. Mevcut ürün sırası gösteriliyor.';
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('Hanezza Bento price sorting fallback:', error && error.message);
      }
    } finally {
      clearTimeout(timer);
      grid.classList.remove('bento-price-sort-loading');
      grid.removeAttribute('aria-busy');
      if (!success && hadLoadMore) loadMoreBtn.disabled = oldDisabled;
    }
  }

  function initializeBentoCollection() {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return;
    var rootEl = document.querySelector('.bento-collection[data-bento-color-spread="true"]');
    if (!rootEl) return;
    var grid = rootEl.querySelector('.bento-grid');
    if (!grid || grid.dataset.bentoSpreadReady === 'true') return;
    grid.dataset.bentoSpreadReady = 'true';
    var sortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
      loadAllVariantPrices(grid, sortBy, rootEl);
      return;
    }
    if (!shouldDisperse(sortBy)) return;
    function isCard(node) {
      return node && node.nodeType === 1 && node.matches('.bento-card[data-product-id]');
    }
    function reorder(nodes, previousId, initial) {
      var cards = nodes.filter(isCard);
      if (cards.length < 2) return;
      var ordered = disperseCards(cards, function (el) { return el.dataset.productId; }, previousId);
      var changed = ordered.some(function (card, index) { return card !== cards[index]; });
      if (!changed) return;
      var promos = initial ? Array.prototype.filter.call(grid.children, function(el) {
        return el.classList && el.classList.contains('bento-promo-card');
      }) : [];
      var orderedNodes = initial ? insertPromoAfterTen(ordered, promos) : ordered;
      var frag = document.createDocumentFragment();
      orderedNodes.forEach(function (node) { frag.appendChild(node); });
      if (initial) grid.replaceChildren(frag);
      else grid.appendChild(frag);
    }
    reorder(Array.prototype.slice.call(grid.children), null, true);
    // The initial card order is now stable; reveal it before the first paint.
    document.documentElement.classList.remove('hanezza-bento-booting');
    var observer = new MutationObserver(function (records) {
      var added = [];
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (isCard(node)) added.push(node);
        });
      });
      if (added.length < 2) return;
      observer.disconnect();
      try {
        var addedSet = new Set(added);
        var previousCards = Array.prototype.filter.call(grid.children, function (el) {
          return isCard(el) && !addedSet.has(el);
        });
        var previousId = previousCards.length ? previousCards[previousCards.length - 1].dataset.productId : null;
        reorder(added, previousId, false);
      }
      finally { observer.observe(grid, { childList: true }); }
    });
    observer.observe(grid, { childList: true });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { disperseCards: disperseCards, shouldDisperse: shouldDisperse, sortVariantCardsByPrice: sortVariantCardsByPrice, buildPricePageUrls: buildPricePageUrls, flattenCompletePricePages: flattenCompletePricePages, insertPromoAfterTen: insertPromoAfterTen, priceScanMode: priceScanMode };
  }
  if (typeof document !== 'undefined') {
    // The section calls this immediately after its grid markup is parsed.
    // Keep DOMContentLoaded as a fallback for deferred asset loading.
    root.hanezzaBentoInitialize = initializeBentoCollection;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBentoCollection, { once: true });
    } else {
      initializeBentoCollection();
    }
  }
})(typeof window !== 'undefined' ? window : {});

//# debugId=993d4d9b-0167-5bd5-adc5-1997b20b2768
